import {
  CloudSearchIcon,
  DateClockIcon,
  DeviceDesktopStarIcon,
  FolderQuestionIcon,
  StudentHatIcon,
  TelevisionIcon,
  UserIcon,
  WindowPlusIcon,
} from "@/icons";
import IconSetting from "@/icons/IconSetting";
import { PathConstant } from "../const";
import { IBreadcrumbItemModel, IMenuItemModel } from "../models";

export enum PermissionKeyEnum {
  SupperAdmin = "CMS.SupperAdmin",
  Home = "CMS.HOME",
  MasterRoot = "CMS.MASTERROOT",
  Permission = "CMS.PERMISSION",
  Role = "CMS.ROLE", // báo cáo thống kê
  SystemConfig = "CMS.SYSTEM_CONFIG",
  AccountAdmin = "CMS.ACCOUNT_ADMIN",
  Account = "CMS.ACCOUNT",
  AccountDelete = "CMS.ACCOUNT.DELETE",
  AccountExport = "CMS.ACCOUNT.EXPORT",
  AccountInsert = "CMS.ACCOUNT.INSERT",
  AccountUpdate = "CMS.ACCOUNT.UPDATE",
  AccountLock = "CMS.ACCOUNT.LOCK",
  AccountPassword = "CMS.ACCOUNT.PASSWORD",
  AccountDetail = "CMS.ACCOUNT.DETAIL",
  Topup = "CMS.TOPUP", // nạp điểm
  TopupDelete = "CMS.TOPUP.DELETE", // xóa lịch sử nạp điểm
  TopupSepay = "CMS.TOPUP.SEPAY", // lịch sử nạp điểm SePay
  WithdrawlRequest = "CMS.WITHDRAWL_REQUEST", // rút điểm
  ProductPurchase = "CMS.PRODUCT_PURCHASE", // lịch sử mua gói
}

export const LIST_MENU_SIDEBAR: IMenuItemModel[] = [
  {
    name: "1. Tổng quan",
    url: PathConstant.HOME,
    icon: <WindowPlusIcon />,
    isActive: false,
  },
  {
    name: "2 Danh sách thành viên",
    url: PathConstant.DANH_SACH_THANH_VIEN,
    isActive: false,
    permission: PermissionKeyEnum.Account,
    icon: <UserIcon />,
  },
  {
    name: "3. Nạp điểm cho thành viên",
    url: PathConstant.NAP_DIEM_THANH_VIEN,
    isActive: false,
    permission: PermissionKeyEnum.Topup,
    icon: <WindowPlusIcon />,
  },
  {
    name: "5. Quản lý rút điểm",
    url: PathConstant.QUAN_LY_RUT_DIEM,
    isActive: false,
    permission: PermissionKeyEnum.WithdrawlRequest,
    icon: <DateClockIcon />,
  },
  {
    name: "6. Lịch sử mua gói",
    url: PathConstant.QUAN_LY_MUA_SAN_PHAM,
    isActive: false,
    permission: PermissionKeyEnum.ProductPurchase,
    icon: <CloudSearchIcon />,
  },
  {
    name: "7. Lịch sử nạp điểm SePay",
    url: PathConstant.LICH_SU_NAP_DIEM_SEPAY,
    isActive: false,
    permission: PermissionKeyEnum.TopupSepay,
    icon: <CloudSearchIcon />,
  },
  // {
  //   name: "2.6 Danh sách tái cấu trúc",
  //   url: PathConstant.QUAN_LY_TAI_CAU_TRUC,
  //   isActive: false,
  //   permission: PermissionKeyEnum.Account,
  //   icon: <DateClockIcon />,
  // },
  {
    name: "8. Hệ Thống",
    url: "",
    icon: <IconSetting />,
    isActive: false,
    children: [
      {
        name: "8.1 Quản lý tài khoản quản trị",
        url: PathConstant.QUAN_TRI_TAI_KHOAN_ADMIN,
        isActive: false,
        permission: PermissionKeyEnum.AccountAdmin,
      },
      {
        name: "8.2 Quản lý vai trò",
        url: PathConstant.QUAN_TRI_VAI_TRO,
        isActive: false,
        permission: PermissionKeyEnum.Role,
      },
      {
        name: "8.3 Quản trị quyền",
        url: PathConstant.QUAN_TRI_QUYEN,
        isActive: false,
        permission: PermissionKeyEnum.Permission,
      },
      {
        name: "8.4 Cấu hình chung",
        url: PathConstant.CAU_HINH_CHUNG,
        isActive: false,
        permission: PermissionKeyEnum.SystemConfig,
      },
      {
        name: "8.5 Cấu hình hệ thống",
        url: PathConstant.CAU_HINH_HE_THONG,
        isActive: false,
        permission: PermissionKeyEnum.SystemConfig,
      },
      {
        name: "8.6 Danh sách ngân hàng",
        url: PathConstant.DANH_SACH_NGAN_HANG,
        isActive: false,
        permission: PermissionKeyEnum.SystemConfig,
      },
    ],
  },
];

export const IMAGE_DEFAULT = "/images/image-default-classonline.png";
export const LIST_ROUTER_NOT_DYNAMIC = [
  "/",
  PathConstant.LECTURES,
  PathConstant.LECTURES_CREATE,
];

export const LIST_BREADCRUMB: IBreadcrumbItemModel[] = [
  {
    name: "Tổng quan",
    path: PathConstant.HOME,
    router: "",
  },
  {
    name: "Quản lý tài khoản quản trị",
    path: PathConstant.QUAN_TRI_TAI_KHOAN_ADMIN,
    router: "",
  },
  {
    name: "Danh sách thành viên",
    path: PathConstant.DANH_SACH_THANH_VIEN,
    router: "",
  },
  {
    name: "Nạp điểm cho thành viên",
    path: PathConstant.NAP_DIEM_THANH_VIEN,
    router: "",
  },
  {
    name: "Quản lý rút điểm",
    path: PathConstant.QUAN_LY_RUT_DIEM,
    router: "",
  },
  {
    name: "Lịch sử mua gói",
    path: PathConstant.QUAN_LY_MUA_SAN_PHAM,
    router: "",
  },
  {
    name: "Lịch sử nạp điểm SePay",
    path: PathConstant.LICH_SU_NAP_DIEM_SEPAY,
    router: "",
  },
  {
    name: "Danh sách tái cấu trúc",
    path: PathConstant.QUAN_LY_TAI_CAU_TRUC,
    router: "",
  },
  {
    name: "Quản lý vai trò",
    path: PathConstant.QUAN_TRI_VAI_TRO,
    router: "",
  },
  {
    name: "Quản lý quyền",
    path: PathConstant.QUAN_TRI_QUYEN,
    router: "",
  },
  {
    name: "Cấu hình chung",
    path: PathConstant.CAU_HINH_CHUNG,
    router: "",
  },
  {
    name: "Cấu hình hệ thống",
    path: PathConstant.CAU_HINH_HE_THONG,
    router: "",
  },
  {
    name: "Danh sách ngân hàng",
    path: PathConstant.DANH_SACH_NGAN_HANG,
    router: "",
  },
];

export enum ThumbSizeEnum {
  Tiny = 200,
  Small = 320,
  Medium = 480,
  Standard = 800,
  Large = 960,
  Hd = 1024,
  FullHd = 2048,
}

export const LIST_ROUTER_PERMISSION: {
  url: string;
  permission: PermissionKeyEnum;
  name: string;
}[] = [
  {
    name: "Quản trị vai trò",
    url: PathConstant.QUAN_TRI_VAI_TRO,
    permission: PermissionKeyEnum.Role,
  },
  {
    name: "Quản trị quyền",
    url: PathConstant.QUAN_TRI_QUYEN,
    permission: PermissionKeyEnum.Permission,
  },
  {
    name: "Quản trị tài khoản quản trị",
    url: PathConstant.QUAN_TRI_TAI_KHOAN_ADMIN,
    permission: PermissionKeyEnum.AccountAdmin,
  },
  {
    name: "Danh sách thành viên",
    url: PathConstant.DANH_SACH_THANH_VIEN,
    permission: PermissionKeyEnum.Account,
  },
  {
    name: "Nạp điểm cho thành viên",
    url: PathConstant.NAP_DIEM_THANH_VIEN,
    permission: PermissionKeyEnum.Topup,
  },
  {
    name: "Quản lý rút điểm",
    url: PathConstant.QUAN_LY_RUT_DIEM,
    permission: PermissionKeyEnum.WithdrawlRequest,
  },
  {
    name: "Lịch sử mua gói",
    url: PathConstant.QUAN_LY_MUA_SAN_PHAM,
    permission: PermissionKeyEnum.ProductPurchase,
  },
  {
    name: "Lịch sử nạp điểm SePay",
    url: PathConstant.LICH_SU_NAP_DIEM_SEPAY,
    permission: PermissionKeyEnum.TopupSepay,
  },
  {
    name: "Danh sách tái cấu trúc",
    url: PathConstant.QUAN_LY_TAI_CAU_TRUC,
    permission: PermissionKeyEnum.Account,
  },
  {
    name: "Cấu hình chung",
    url: PathConstant.CAU_HINH_CHUNG,
    permission: PermissionKeyEnum.SystemConfig,
  },
  {
    name: "Cấu hình hệ thống",
    url: PathConstant.CAU_HINH_HE_THONG,
    permission: PermissionKeyEnum.SystemConfig,
  },
  {
    name: "Danh sách ngân hàng",
    url: PathConstant.DANH_SACH_NGAN_HANG,
    permission: PermissionKeyEnum.SystemConfig,
  },
];
